<template>
  <div id="faz-midterms-widget" v-if="data && loaded">
    <div v-if="source==='test'">
      <select v-model="stage" style="max-width: 300px">
        <option v-for="stage in stages" :key="stage">{{stage}}</option>
      </select>
      <br><br>
    </div>
    <div class="header">
      <!-- <div class="dz"></div> -->
      <div class="hl">Kongresswahlen 2022</div>
      <div class="stand" v-if="computedData.us.type != ''">
        <span v-if="computedData.us.type === 'poll'" class="poll">Umfragen</span>
        <!-- <span v-else class="live">Live</span> -->
        {{ getDate() }}
      </div>
      <div class="stand" v-else>
        Erste Ergebnisse ab 24 Uhr erwartet
      </div>
    </div>
    <div class="chart_blocks">
      <div class="chart_block" v-for="house in computedData2.houses" :key="house.name">
        <div class="hl">{{house.name}} <span> {{house.type}}</span></div>
        <div class="numbers">
          <div class="dem">
            <div class="number">
              {{ house['Demokraten'].bigNumber }}
            </div>
            <div class="numberLabel" :class="{'winner': house['Demokraten'].winner }">
              Demokraten 
              <div class="checkmark" v-if="house['Demokraten'].winner"></div>
            </div>
          </div>
          <div class="rep">
            <div class="numberLabel" :class="{'winner': house['Republikaner'].winner }">
              <div class="checkmark" v-if="house['Republikaner'].winner"></div>
              Republikaner
            </div>
            <div class="number">
              {{ house['Republikaner'].bigNumber }}
            </div>
          </div>
        </div>
        <StackedBarChart 
          :data="house.name === 'Repräsentantenhaus' ? seatsHouse : seatsSenate" 
          :majority="house.majorityLabel"
          :senate="house.name === 'Senat'"
        />
        <div class="chartLegends" v-if="house.type != 'Vorläufiges Endergebnis'">
          <div class="chartLegend dem" v-if="house['Demokraten'].seats.length > 1">
            <div v-for="category in house['Demokraten'].seats" :key="category.color" :style="{color: category.color}">
              {{category.label}}: {{category.number}}
            </div>
          </div>
          <div class="chartLegend rep" v-if="house['Republikaner'].seats.length > 1">
            <div v-for="category in house['Republikaner'].seats" :key="category.color" :style="{color: category.color}">
              {{category.label}}: {{category.number}}
            </div>
          </div>
          <div class="chartLegend center" v-if="house['Demokraten'].seats.length>1">
            Prognostizierte Sitzgewinne
          </div>
        </div>
        <div class="chartLegends" v-else>
          <div class="chartLegend dem">
            <div style="color: #577BB7" v-if="house['Demokraten'].change">
              {{house['Demokraten'].change}}
            </div>
          </div>
          <div class="chartLegend rep">
            <div style="color: #D13D3D" v-if="house['Republikaner'].change">
              {{house['Republikaner'].change}}
            </div>
          </div>
          <div v-if="house['Unabhängige']>0" class="chartLegend independent">
            Unabhängige: {{house['Unabhängige']}}
          </div>
        </div>
      </div>
    </div>
    <div class="quelle" v-if="computedData.us.source === '' && computedData['us-se'].source === ''">
      Grafik: jpg., rago.
    </div>
    <div class="quelle" v-else-if="computedData.us.source === computedData['us-se'].source">
      Quelle: {{ computedData.us.source }} / Grafik: jpg., rago.
    </div>
    <div class="quelle" v-else-if="computedData.us.source === '' || computedData['us-se'].source === ''">
      Quelle: {{ computedData.us.source }} / Grafik: jpg., rago.
    </div>
    <div class="quelle" v-else>
      Quellen: {{ computedData.us.source }}, {{ computedData['us-se'].source }} / Grafik: jpg., rago.
    </div>
    <div class="redirectButton" 
      v-if="computedData.us.type != '' && computedData.us.type != 'poll'"
      onclick="location.href='https://www.faz.net/1.8385050';"
      >
      Ergebnisse im Detail
    </div>
    <div  v-if="source!='live_or_poll'">
      <br><br><br>
      <pre>{{ computedData }}</pre>
      <hr>
      <!-- <pre>{{ computedData2 }}</pre> -->
    </div>
  </div>
</template>

<script>
import StackedBarChart from './components/StackedBarChart.vue'
// Do-Do's
// zwei verschiedene Quellen (NYT, CNN)
// Unterscheidung poll, exit_poll, projection, official 

export default {
  name: 'App',
  components: {
    StackedBarChart
  },
  data() {
    return {
      source: null,
      data: null,
      loaded: false,
      simlive: "sim",
      stages: [
        'midterms_widget.json',
        'midterms_widget_test.json',
        'sim0_empty.json.json',
        'sim1_house_overall_trend.json.json',
        'sim2_house_overall_trend_update.json.json',
        'sim3_house_overall_trend_update_corner_case_independent_seat.json.json',
        'sim4_house_overall_preliminary.json.json',
        'sim5_senate_overall_trend.json.json',
        'sim6_senate_overall_trend_update.json.json',
        'sim7_senate_overall_trend_update.json.json',
        'sim8_senate_overall_preliminary.json.json',
        'sim11_complete.json.json',
        "sim2_0_empty.json",
        "sim2_1_trend_house.json",
        "sim2_2_trend_update_house.json",
        "sim2_3_trend_update_with_one_independet_in_house.json",
        "sim2_4_preliminary_house.json","sim2_5_trend_senate.json",
        "sim2_6_trend_update_senate.json",
        "sim2_7_trend_update_senate.json",
        "sim2_8_preliminary_senate.json",
        "sim2_9_senate_constituency_indiana_exit_poll.json",
        "sim2_10_senate_constituency_indiana_kentucky_trend.json",
        "sim2_11_senate_constitency_oklahoma_louisiana_florida_trend.json",
        "sim2_12_complete.json",
        "sim3_0_empty.json","sim3_1_trend_house.json","sim3_2_trend_update_house.json","sim3_3_trend_update_with_one_independet_in_house.json","sim3_4_preliminary_house.json","sim3_5_trend_senate.json","sim3_6_trend_update_senate.json","sim3_7_preliminary_senate.json","sim3_8_senate_constituency_indiana_exit_poll.json","sim3_9_senate_constituency_indiana_kentucky_trend.json","sim3_10_senate_constitency_batch_update.json","sim3_11_complete.json"
      ],
      stage: 'sim1_house_overall_trend.json.json',
      types: {
        'poll': 'Umfrage',
        'exit_poll': 'Prognose',
        'projection': 'Hochrechnung',
        'trend': 'Zwischenergebnis',
        'preliminary': 'Vorläufiges Endergebnis',
        'official': 'Ergebnisse',
        '': 'Es liegen noch keine Ergebnisse vor'
      },
      colors: {
        'Demokraten': {
          'safe': '#577BB7',
          'likely': '#849DC7',
          'leans': '#B2C0D8',
        },
        'Republikaner': {
          'safe': '#D13D3D',
          'likely': '#D97272',
          'leans': '#E3A7A7',
        }
      }
    }
  },
  methods: {
    getData () {
      let jsons = [
        'midterms_widget.json',
        'midterms_widget_test.json',
        'sim0_empty.json.json',
        'sim1_house_overall_trend.json.json',
        'sim2_house_overall_trend_update.json.json',
        'sim3_house_overall_trend_update_corner_case_independent_seat.json.json',
        'sim4_house_overall_preliminary.json.json',
        'sim5_senate_overall_trend.json.json',
        'sim6_senate_overall_trend_update.json.json',
        'sim7_senate_overall_trend_update.json.json',
        'sim8_senate_overall_preliminary.json.json',
        'sim11_complete.json.json',
        "sim2_0_empty.json",
        "sim2_1_trend_house.json",
        "sim2_10_senate_constituency_indiana_kentucky_trend.json",
        "sim2_11_senate_constitency_oklahoma_louisiana_florida_trend.json",
        "sim2_12_complete.json","sim2_2_trend_update_house.json",
        "sim2_3_trend_update_with_one_independet_in_house.json",
        "sim2_4_preliminary_house.json","sim2_5_trend_senate.json",
        "sim2_6_trend_update_senate.json",
        "sim2_7_trend_update_senate.json",
        "sim2_8_preliminary_senate.json",
        "sim2_9_senate_constituency_indiana_exit_poll.json",
        "sim3_0_empty.json","sim3_1_trend_house.json","sim3_10_senate_constitency_batch_update.json","sim3_11_complete.json","sim3_2_trend_update_house.json","sim3_3_trend_update_with_one_independet_in_house.json","sim3_4_preliminary_house.json","sim3_5_trend_senate.json","sim3_6_trend_update_senate.json","sim3_7_preliminary_senate.json","sim3_8_senate_constituency_indiana_exit_poll.json","sim3_9_senate_constituency_indiana_kentucky_trend.json"
      ]
      if(this.source === 'test') { 
        let d = []
        jsons.forEach( j => {
          fetch(`https://cdn.faz-azure.com/multimediaredaktion/midterms/${j}?sv=2020-10-02&st=2022-07-07T19%3A02%3A35Z&se=2222-07-08T19%3A02%3A00Z&sr=c&sp=r&sig=nrn9mbdYgd9tqIUMSSZ7P8RIaG1z%2BOBPyqC%2FTwRf7u0%3D`)
          .then((response) => response.json())
          .then((data) => {
            if(j === 'midterms_widget_test.json') {
              d.push({stage: j, data: data.live_or_poll}) //.replace('sim','').replace('.json.json','')
            } else {
              console.log(j, data)
              d.push({stage: j, data: data.simu})
            }
          })
        })
        this.data = d
      } else {
        fetch(`https://cdn.faz-azure.com/multimediaredaktion/midterms/midterms_widget.json?sv=2020-10-02&st=2022-07-07T19%3A02%3A35Z&se=2222-07-08T19%3A02%3A00Z&sr=c&sp=r&sig=nrn9mbdYgd9tqIUMSSZ7P8RIaG1z%2BOBPyqC%2FTwRf7u0%3D`)
        .then((response) => response.json())
        .then((data) => {
          this.data = data
        })
      }
      this.loaded = true
      // console.log('loaded', this.data)

      setTimeout( () => { 
        this.getData()
        console.log("Update!")
      }, 60000)
    },
    getRepWidth: function (seats) {
      let width = seats / 435 * 100
      return width
    },
    formatDate: function (str) {
      return 'Stand: ' + str.replaceAll('/','.').slice(0,-3) + ' Uhr'
    },
    getDate: function () {
      let house = this.computedData['us'].parse_date
      let senate = this.computedData['us-se'].parse_date
      if(house === "" && senate === "") {
        return ''
      } else {
        if(house>senate) {
          return 'Stand: ' + house
        } else {
          return 'Stand: ' + senate
        }
      }
    },
    getSeatsArray: function (obj, party) {
      if(!obj.safe) { 
        return [
        //   {
        //   "label": "sicher",
        //   "number": 0,
        //   "color": "pink"
        // }
      ]
      } else {
        return Object.keys(obj).map((key) => {
          return {
            "id": key,
            "label": this.getLabelTranslation(key),
            "number": obj[key],
            "color": this.colors[party][key]
          }
        }).sort( (a, b) => b.id.localeCompare(a.id))
        .filter( el => ['safe', 'likely', 'leans'].indexOf(el.id) >= 0)
      }
    },
    getLabelTranslation: function (str) {
      let poll = {
        'safe': 'fest erwartet',
        'likely': 'erwartet',
        'leans': 'eher erwartet'
      }
      let trend = {
        'safe': 'sicher',
        'likely': 'fest erwartet',
        'leans': 'eher erwartet'
      }

      if(this.computedData.us.type === 'poll') {
        return poll[str]
      } else {
        return trend[str]
      }
    }
  },
  computed: {
    computedData: function () {
      if(this.source === 'test') {
        if(this.data.find( el => el.stage === this.stage )) {
          return this.data.find( el => el.stage === this.stage ).data
        } else {
          return []
        }
      } else {
        return this.data[this.source]
      }
    },
    computedData2: function () {
      let data, house, senate = null
      if(this.source === 'test') {
        data = this.data.find( el => el.stage === this.stage ).data
        house = data['us']
        senate = data['us-se']
      } else {
        data = this.data
        house = data[this.source]['us']
        senate = data[this.source]['us-se']
      }

      let obj = {
        "houses": [
          {
            "name": "Repräsentantenhaus",
            "type": this.types[house.type] || "",
            "majorityLabel": "Mehrheit bei 218 Sitzen",
            "Demokraten": {
              "bigNumber": house.type === 'poll' ? house['Demokraten'].total : house['Demokraten'].safe || 0,
              "seats": this.getSeatsArray(house['Demokraten'], 'Demokraten'),
              "winner": house.type != 'poll' && house['Demokraten'].safe >= 218
            },
            "Republikaner": {
              "bigNumber": house.type === 'poll' ? house['Republikaner'].total : house['Republikaner'].safe || 0,
              "seats": this.getSeatsArray(house['Republikaner'], 'Republikaner'),
              "winner": house.type != 'poll' && house['Republikaner'].safe >= 218
            }
          },
          {
            "name": "Senat",
            "type": this.types[senate.type] || "",
            "majorityLabel": "50",
            "Demokraten": {
              "bigNumber": senate.type === 'poll' ? senate['Demokraten'].total : senate['Demokraten'].safe || 36,
              "seats": this.getSeatsArray(senate['Demokraten'], 'Demokraten'),
              "winner": senate.type != 'poll' && senate['Demokraten'].safe >= 50
            },
            "Republikaner": {
              "bigNumber": senate.type === 'poll' ? senate['Republikaner'].total : senate['Republikaner'].safe || 29,
              "seats": this.getSeatsArray(senate['Republikaner'], 'Republikaner'),
              "winner": senate.type != 'poll' && senate['Republikaner'].safe > 50
            }
          }
        ]
      }

      if(house['Independent'] && house['Independent'].safe>0) {
        obj.houses[0]["Unabhängige"] = house['Independent'].safe
      }

      if(house.type === 'preliminary') {
        let change_dem = house['Demokraten'].safe - 220
        let change_rep = house['Republikaner'].safe - 212

        if(change_dem>0) {
          obj.houses[0]["Demokraten"]["change"] = "gewinnen " + change_dem + " Sitze"
        } else if (change_dem<0) {
          obj.houses[0]["Demokraten"]["change"] = "verlieren " + Math.abs(change_dem) + " Sitze"
        }

        if(change_rep>0) {
          obj.houses[0]["Republikaner"]["change"] = "gewinnen " + change_rep + " Sitze"
        } else if (change_rep<0) {
          obj.houses[0]["Republikaner"]["change"] = "verlieren " + Math.abs(change_rep) + " Sitze"
        }
      }

      if(senate.type === 'preliminary') {
        let change_dem = senate['Demokraten'].safe - 50
        let change_rep = senate['Republikaner'].safe - 50

        if(change_dem>0) {
          obj.houses[1]["Demokraten"]["change"] = "gewinnen " + change_dem + " Sitze"
        } else if (change_dem<0) {
          obj.houses[1]["Demokraten"]["change"] = "verlieren " + Math.abs(change_dem) + " Sitze"
        }

        if(change_rep>0) {
          obj.houses[1]["Republikaner"]["change"] = "gewinnen " + change_rep + " Sitze"
        } else if (change_rep<0) {
          obj.houses[1]["Republikaner"]["change"] = "verlieren " + Math.abs(change_rep) + " Sitze"
        }
      }

      return obj
    },
    seatsHouse: function () {
      let dems = this.computedData2.houses[0]['Demokraten'].seats
      let reps = this.computedData2.houses[0]['Republikaner'].seats
      let dem_sum = dems.reduce( (acc, obj) => { return acc + obj.number; }, 0)
      let rep_sum = reps.reduce( (acc, obj) => { return acc + obj.number; }, 0)

      return [
        ...dems, 
        ...[{
          "number": 435 - (dem_sum + rep_sum),
          "color": "#efefef"
        }],
        ...[...reps].reverse()
      ]
    },
    seatsSenate: function () {
      let dems = this.computedData2.houses[1]['Demokraten'].seats
      let reps = this.computedData2.houses[1]['Republikaner'].seats
      let dem_sum = dems.reduce( (acc, obj) => { return acc + obj.number; }, 0)
      let rep_sum = reps.reduce( (acc, obj) => { return acc + obj.number; }, 0)

      return [
        ...dems, 
        ...[{
          "number": 100 - (dem_sum + rep_sum),
          "color": "#efefef"
        }],
        ...[...reps].reverse()
      ]
    },
  },
  mounted() {
    this.getData()
  },
  beforeMount() {
    this.source = this.$parent.$el.getAttribute("source")
    console.log('beforeMount: ', this.source);
  }
}
</script>

<style lang="scss">
@import "./assets/style.scss";
</style>
